// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__ki4m6","logo__image":"logo_logo__image__B2ex+","logo__description":"logo_logo__description__I0zYf","logo__description_image":"logo_logo__description_image__eRmod"};